import { Component, Emit, Prop } from 'vue-property-decorator'
import GridHeader from '@/components/GridHeader.vue'
import GridDisplayOptions from '@/components/GridDisplayOptions.vue'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import BaseCrudServerSideComponent from '@/shared/resources/base-crud-server-side.component'
import { BaseCrud } from '@/shared/models/cruds.models'
import {
    BillingAddToGridState,
    initialBillingAddToGridState
} from '@/modules/billing-module/shared/components/add-to-grid/billing-add-to-grid.model'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { GetContextMenuItemsParams, MenuItemDef } from '@ag-grid-enterprise/all-modules'

@Component({
    components: {
        GridHeader,
        GridDisplayOptions,
        VtGrid
    }
})
export default class BillingAddToGrid<R> extends BaseCrudServerSideComponent<R> implements BaseCrud {
    @Prop({ type: Object, required: true }) readonly datasource!: PaginatorLaboratoryDatasource<R>
    @Prop({ type: String, required: true }) readonly title!: string
    @Prop({ type: String, required: true }) readonly addToMode!: string
    @Prop({ type: String, required: true }) readonly addToActionLabel!: string

    @Emit()
    selected(): R {
        return this.state.selectedRows[0]
    }

    state: BillingAddToGridState<R>
    constructor() {
        super()
        this.state = initialBillingAddToGridState()
    }

    /// GRID COMPUTED ///

    get gridSubtitle(): string {
        if (this.state.selectedRows.length) {
            const choice = this.state.selectedRows.length > 1 ? 2 : 1
            return `${this.state.selectedRows.length} ${this.$tc('global.selectedElements', choice)}`
        }
        return ''
    }

    get canAdd(): boolean {
        return !!this.state.selectedRows.length
    }

    /// VUE HOOKS ///

    created(): void {
        this.state.gridOptions.rowSelection = 'single'
        this.state.gridUiComponent = `uicomponent.billing.grid.addTo.${this.addToMode}`
    }

    mounted(): void {
        this.state.datasource = this.datasource
        this.state.columnsDef = this.datasource.columnDefs
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        const menuItems: MenuItemDef[] = []
        if (this.canAdd) {
            menuItems.push({
                name: this.$tc(this.addToActionLabel),
                action: this.selected
            })
        }
        return menuItems
    }
}
